package one.healthium.tasks.navigation

import androidx.compose.runtime.Composable
import one.healthium.tasks.ui.DailyTasksScreen

@Composable
fun DailyTasksContent(component: DailyTasksComponent) {
    DailyTasksScreen(component)
}